import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';


const theme = {
    styles: {
        global:
        {
            ".page-layout": {
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignContent: "center",
                alignItems: "center",
                width: '100% !important',
            },
            "#CollectJSIframe": {
                zIndex: 1600, // Card input box was being hidden by modal and modal overlay
            },
            '.CollectJSFade': {
                zIndex: 1500,
            }
        }
    },
    colors: {
        primary: {
            50: '#E6FFFA',
            main: "#1793A1",
            500: "#1793A1",
        }
    },
    variants: {
        primary: {
            colorScheme: "primary",
        }
    },
    components: {
        Input: {
            defaultProps: {
                focusBorderColor: '#008080',
            },
        },
        Textarea: {
            defaultProps: {
                focusBorderColor: '#008080',
            },
        },
        Select: {
            defaultProps: {
                focusBorderColor: '#008080',
            },
        },
        Button: {
            baseStyle: {
                borderRadius: "lg",
                _hover: {
                    backgroundColor: "#F48842",
                },
            },
        },
    },
}

export default extendTheme(theme, withDefaultColorScheme({ colorScheme: "primary" }));